<template>
  <div id="score-report">
    <div class="md-layout mb-2">
      <div class="md-layout-item md-size-100">
        <div @click="goToPreviousPage">
          <span class="header-title"
            >&lt; {{ $t("survey_report.report") + " : " + title }}</span
          >
        </div>
      </div>
    </div>
    <div class="tabs border-t border-gray-300">
      <button
        v-for="(tab, idx) in tabs"
        :key="tab.name"
        :class="['tab-button', { active: currentTabIdx === idx }]"
        @click="currentTabIdx = idx"
      >
        {{ tab.label }}
      </button>

      <keep-alive>
        <component
          :is="tabs[currentTabIdx].component"
          class="tab"
          @updateTitle="updateTitle"
        ></component>
      </keep-alive>
    </div>
  </div>
</template>
<script>
import Individual from "./Individual";
import Summarize from "./Summarize";
import { hasHistory } from "@/helpers/utils";
export default {
  data() {
    return {
      title: "",
      currentTabIdx: 0
    };
  },
  computed: {
    tabs() {
      return [
        {
          name: "survey-individual",
          label: this.$t("survey_report.survey_individual"),
          component: Individual
        },
        {
          name: "survey-summarize",
          label: this.$t("survey_report.survey_summarize"),
          component: Summarize
        }
      ];
    }
  },
  methods: {
    goToPreviousPage() {
      hasHistory() ? this.$router.go(-1) : this.$router.push("/");
    },
    updateTitle(value) {
      this.title = value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~vue-material/dist/theme/engine";

.tab-button {
  @apply py-2 px-4;
  @apply text-gray-500 font-medium;
  @apply cursor-pointer;
  @apply outline-none;

  font-size: 1rem;

  &.active {
    border-top: 2px solid md-get-palette-color(purple, 500);
  }
}
.header-title {
  font-weight: 500;
  font-size: 26px;
  line-height: 36px;
  letter-spacing: 0.18px;
  color: #1b1f22;
  cursor: pointer;
}
</style>
